import { Component, inject, input, signal } from '@angular/core';
import { IonHeader, IonToolbar, IonButtons, IonButton, IonTitle } from "@ionic/angular/standalone";
import { LocalizationModule } from "../../../../../modules/localization/localization.module";
import { EntityReadComponent } from "../../../../entity/entity-read/entity-read.component";
import { ModalService } from 'src/app/services/modal.service';
import { ApiService } from 'src/app/services/api.service';
import { ToastService } from 'src/app/services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RejectionReasonComponent } from './rejection-reason/rejection-reason.component';

@Component({
  selector: 'app-approval-details',
  templateUrl: './approval-details.component.html',
  styleUrls: ['./approval-details.component.scss'],
  standalone: true,
  imports: [IonTitle, IonButton, IonButtons, IonToolbar, IonHeader, LocalizationModule, EntityReadComponent]
})
export class ApprovalDetailsComponent {
  modalService = inject(ModalService);
  apiService = inject(ApiService);
  toastService = inject(ToastService);

  inAction = signal(false);

  entityId = input<number>();
  modalId = input<string>();

  async approved() {
    if (this.inAction()) return;
    this.inAction.set(true);
    try {
      const response = await this.apiService.postAsync('/admin/approve', { body: { entityId: this.entityId() } });
      this.toastService.success(response.message);
      this.modalService.close(this.modalId()!, true);
    } catch (e) {
      const error = e as HttpErrorResponse;
      this.toastService.error(error.error.message ?? 'There was an error approving your entity');
    } finally {
      this.inAction.set(false);
    }
  }

  async reject() {
    if (this.inAction()) return;
    const reason = await this.promptRejectionReason();
    if (!reason) return;
    this.inAction.set(true);
    try {
      const response = await this.apiService.postAsync('/admin/reject', { body: { entityId: this.entityId(), reason } });
      this.toastService.success(response.message);
      this.modalService.close(this.modalId()!, true);
    } catch (e) {
      const error = e as HttpErrorResponse;
      this.toastService.error(error.error.message ?? 'There was an error approving your entity');
    } finally {
      this.inAction.set(false);
    }
  }

  async promptRejectionReason() {
    const MODAL_ID = 'rejection-reason';
    const response = await this.modalService.open<string>(RejectionReasonComponent, {
      componentProps: {
        modalId: MODAL_ID,
      },
      canDismiss: true,
      handle: true,
      id: MODAL_ID,
    });
    return response.data;
  }
}

export type ApprovalResult = 'approved' | 'rejected' | undefined;